import handleInit from './handleInit';
import mapItemsToTemplates from './mapItemsToTemplates';

/**
 * Returns a callback that resets the component to the given items.
 * @param {Element} component
 * @param {jQuery} $templates
 * @return {Function} A callback function
 */
const handleItemsReset = (component, $templates) => (e, items) => {
    const wrappedItems = mapItemsToTemplates(items, $templates);

    // update DOM
    $(component).find('.grid').empty().append(wrappedItems);
    // re-init component
    handleInit(component)();
};

export default handleItemsReset;



// WEBPACK FOOTER //
// ./src/scripts/components/masonry/handleItemsReset.js